import { render, staticRenderFns } from "./FeatureDetails.vue?vue&type=template&id=19acffb6"
import script from "./FeatureDetails.vue?vue&type=script&lang=js"
export * from "./FeatureDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports